module.exports = __webpack_public_path__ + "static/media/about-background.b6ec2625.jpg";